import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel
} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import useStyles from '../styles';

export default function EditVersionFooter({
  isModal,
  showCommitment,
  isCommitmentChecked,
  onCommitmentChange,
  onClose,
  submitDisabled,
  submitting,
  submitLabel = 'Lưu lại'
}) {
  const classes = useStyles();

  return (
    <Box
      className={clsx(
        classes.footerBar,
        isModal && classes.footerBarModal
      )}
    >
      {showCommitment && (
        <Box className={classes.commitmentBox}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isCommitmentChecked}
                onChange={e => onCommitmentChange(e.target.checked)}
                color="primary"
              />
            }
            label="Tôi cam kết các thông tin khai báo là chính xác. Nếu có sai lệch tôi hoàn toàn chịu trách nhiệm."
          />
        </Box>
      )}
      <div className={classes.groupButtonSubmit}>
        <div className={classes.buttonGroup}>
          {onClose && (
            <Button
              onClick={onClose}
              className={classes.secondaryButton}
              size="small"
              variant="outlined"
            >
              Thoát
            </Button>
          )}
          <Button
            className={classes.primaryButton}
            size="small"
            disabled={submitDisabled}
            type="submit"
            variant="contained"
          >
            {submitLabel}
          </Button>
        </div>
        {submitting && (
          <CircularProgress
            size={22}
            className={classes.buttonProgress}
          />
        )}
      </div>
    </Box>
  );
}
